<template>
  <div>
    <div id="print-report">
      <!-- PRINT ONLY -->
      <div class="caption d-none d-print-block mb-3">
        <HeaderPrint />
        <div>
          {{ $t("FilteredPeriod") }}:
          {{ $date.formatRange(rangeDate) }}
        </div>
      </div>
      <!-- end/ PRINT ONLY -->
      <v-card class="mb-3">
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="9">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left> mdi-printer </v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="d-md-none">
              <div class="text-right">
                <v-btn-toggle dense>
                  <v-btn @click="breakpoint = 0">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>
                  <v-btn @click="breakpoint = 'xs'">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3"> </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="name"
          class="elevation-1 mb-3"
          :search="search"
          :dense="$vuetify.breakpoint.smAndDown"
          @current-items="resume"
          :items-per-page="-1"
          :hide-default-footer="true"
          sort-by="sales_bets"
          :sort-desc="true"
          :mobile-breakpoint="breakpoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template
            v-for="(key, index) in headers"
            v-slot:[`item.${key.value}`]="{ item }"
          >
            <!-- <span :key="index" :class="getColor(item[key])">{{
              item[key]
            }}</span> -->

            <a
              v-if="index == 0"
              :key="key + index"
              @click="
                $profile.showProfileDrawer(
                  item.id_agent,
                  'localManager/agents/getAgent'
                )
              "
            >
              {{ item.name_agent }}
            </a>

            <span
              v-else
              :key="key + index"
              :class="getColor(item[key.value], index)"
              >{{ item[key.value] }}</span
            >
          </template>
        </v-data-table>
      </v-card>

      <!-- Resume -->
      <div class="mt-4" v-if="items.length != 0">
        <v-row>
          <v-col v-if="$vuetify.breakpoint.smAndUp" sm="6" md="8"></v-col>
          <v-col cols="12" xs="12" sm="6" md="4">
            <v-card class="pa-3">
              <div class="subtitle-1 mb-2">
                {{ $t("resumeSummary") }}
                <v-icon class="float-right mr-3" @click="$copy(resumeCopy)">
                  mdi-content-copy
                </v-icon>
                <div class="caption">{{ $store.state.rangeUI }}</div>
              </div>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td>{{ $t("qtdBets") }}</td>
                      <td class="text-right">{{ some.countBet || 0 }}</td>
                    </tr>
                    <tr>
                      <td>{{ $t("qtdSalesCredit") }}</td>
                      <td class="text-right">{{ some.countCredit || 0 }}</td>
                    </tr>

                    <tr>
                      <td>{{ $t("revenueLabel") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.salesBets)">{{
                          some.salesBets || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("agentsComissionsLabel") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.commissionBets)">{{
                          some.commissionBets || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("creditSales") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.salesCredits)">{{
                          some.salesCredits || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("salesCreditCommi") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.commissionCredits)">{{
                          some.commissionCredits || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr v-if="some.typeComission == 'ngr'">
                      <td>{{ $t("comissionGerLocal") }}</td>
                      <td class="text-right">
                        <span
                          :class="
                            cleanPositiveValueUI(some.commissionLocal)
                              .classColor
                          "
                        >
                          {{ cleanPositiveValueUI(some.commissionLocal).value }}
                        </span>
                      </td>
                    </tr>

                    <tr v-else>
                      <td>{{ $t("comissionGerLocal") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.commissionLocal)">{{
                          some.commissionLocal || 0
                        }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>{{ $t("cancellations") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.cancellations)">{{
                          some.cancellations || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("awards") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.prizesPaid)">{{
                          some.prizesPaid || 0
                        }}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>{{ $t("grossProfit") }}</td>
                      <td class="text-right">
                        <span :class="getColor(some.grossProfit)">{{
                          some.grossProfit || 0
                        }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPrint from "@/components/common/header-print";

export default {
  name: "local-manager-financial-apuration",
  components: {
    HeaderPrint,
  },
  data: () => ({
    breakpoint: "xs",
    items: [],
    search: "",
    some: {},
    resumeCopy: "",
  }),

  mounted() {
    // this.requestApi();
  },

  computed: {
    rangeDate() {
      return this.$store.state.range.date;
    },
    id_agent() {
      return this.$store.state.filters.autocompleteAgents.id;
    },
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    headers() {
      return [
        { text: this.$t("agent"), value: "name_agent" },
        { text: this.$t("qtdBets"), value: "count_bets" },
        { text: this.$t("betsLabel"), value: "sales_bets" },
        { text: this.$t("cancelledBets"), value: "cancellations" },
        { text: this.$t("coAgentBet"), value: "commission_bets" },
        { text: this.$t("qtyCredits"), value: "count_credits" },
        { text: this.$t("credits"), value: "sales_credits", align: " amount" },
        { text: this.$t("coAgentCredit"), value: "commission_credits" },
        { text: this.$t("awards"), value: "prizes_paid" },
        { text: this.$t("coGerLocal"), value: "comission_local" },
        { text: this.$t("grossProfit"), value: "gross_profit" },
      ];
    },
  },

  watch: {
    saveFilters(val) {
      val && this.requestApi();
    },
  },

  methods: {
    resetPage() {
      this.search = "";
      this.some = {};
    },

    async requestApi() {
      this.resetPage();

      const body = {
        ...this.rangeDate,
        id_agente: this.id_agent,
        export: this.exportDoc,
      };
      let response;
      if (this.exportDoc) {
        var extension = this.exportDoc;
        response = await this.$request.exportDoc(
          "/localManager/financial/extract",
          body,
          extension,
          this.rangeDate
        );
      } else {
        response = await this.$request.post(
          "/localManager/financial/extract",
          body
        );
      }
      if (!response.dados) {
        this.items = [];
        return;
      }

      this.items = response.dados;
      // De acordo com o type_comission "bruto" ou "ngr" o valor a comissão do Local será alterada
      // Caso seja 'ngr' o valor do somatório será commission_ngr_local
      this.items.forEach((item) => {
        if (item.type_comission == "ngr") {
          item.comission_local = Number(item.comission_ngr_local).toFixed(2);
          item.gross_profit = item.gross_profit_ngr;
        } else {
          item.comission_local = Number(item.comission_local).toFixed(2);
        }
      });
      var dt_start = response.date_start.replace(" ", "T");
      var dt_end = response.date_final.replace(" ", "T");
      this.$date.buildRangeUi(dt_start, dt_end);
    },

    setData(data) {
      this.resetPage();
      this.apuration = data;
    },

    resume(item) {
      this.resetPage();

      item.forEach((item) => {
        this.some.typeComission = item.type_comission;
        this.some.countBet =
          (this.some.countBet || 0) + Number(item.count_bets);

        this.some.salesBets =
          (this.some.salesBets || 0) + Number(item.sales_bets);

        this.some.commissionBets =
          (this.some.commissionBets || 0) + Number(item.commission_bets);

        this.some.countCredit =
          (this.some.countCredit || 0) + Number(item.count_credits);

        this.some.salesCredits =
          (this.some.salesCredits || 0) + Number(item.sales_credits);

        this.some.commissionCredits =
          (this.some.commissionCredits || 0) + Number(item.commission_credits);

        this.some.commissionLocal =
          (this.some.commissionLocal || 0) + Number(item.comission_local);

        this.some.cancellations =
          (this.some.cancellations || 0) + Number(item.cancellations);

        this.some.prizesPaid =
          (this.some.prizesPaid || 0) + Number(item.prizes_paid);

        this.some.grossProfit =
          (this.some.grossProfit || 0) + Number(item.gross_profit);
      });

      // Apenas 2 casas decimais
      if (this.some.grossProfit == undefined) return;

      if (this.some.commissionLocal < 0 && this.some.typeComission == "ngr") {
        this.some.grossProfit = (
          this.some.grossProfit + this.some.commissionLocal
        ).toFixed(2);
      } else {
        this.some.grossProfit = this.some.grossProfit.toFixed(2);
      }

      this.some.salesBets = this.some.salesBets.toFixed(2);
      this.some.commissionBets = this.some.commissionBets.toFixed(2);
      this.some.salesCredits = this.some.salesCredits.toFixed(2);
      this.some.commissionCredits = this.some.commissionCredits.toFixed(2);
      this.some.commissionLocal = this.some.commissionLocal.toFixed(2);
      this.some.cancellations = this.some.cancellations.toFixed(2);
      this.some.prizesPaid = this.some.prizesPaid.toFixed(2);

      // To Copy
      this.some.grossProfitCopy = this.some.grossProfit
        .toString()
        .replace(".", ",");
      this.some.salesBetsCopy = this.some.salesBets
        .toString()
        .replace(".", ",");
      this.some.commissionBetsCopy = this.some.commissionBets
        .toString()
        .replace(".", ",");
      this.some.salesCreditsCopy = this.some.salesCredits
        .toString()
        .replace(".", ",");
      this.some.commissionCreditsCopy = this.some.commissionCredits
        .toString()
        .replace(".", ",");
      this.some.commissionLocalCopy = this.some.commissionLocal
        .toString()
        .replace(".", ",");
      this.some.cancellationsCopy = this.some.cancellations
        .toString()
        .replace(".", ",");

      this.some.prizesPaidCopy = this.some.prizesPaid
        .toString()
        .replace(".", ",");

      this.resumeCopy = `${this.some.countBet}
        ${this.some.countCredit}
        ${this.some.salesBetsCopy}
        ${this.some.commissionBetsCopy}
        ${this.some.salesCreditsCopy}
        ${this.some.commissionCreditsCopy}
        ${this.some.commissionLocalCopy}
        ${this.some.cancellationsCopy}
        ${this.some.prizesPaidCopy} 
        ${this.some.grossProfitCopy}`;
    },
    getColor(value, index) {
      // Return Agente, Qtd Apostas, Qtd Crétido;
      if (index == 0 || index == 1 || index == 5) return;
      //
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },
    cleanPositiveValueUI(value) {
      if (value < 0) {
        return {
          value: `0  (${value * -1})`,
          classColor: "grey--text darken-4",
        };
      } else {
        return { value: value, classColor: this.getColor(value) };
      }
    },
  },
};
</script>
